import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface FollowUpModalProps {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  width?: string | number;
  maxWidth?: string | number;
  height?: string | number;
  scroll?: "paper" | "body";
  showCloseIcon?: boolean;
  dialogSx?: any;
  contentSx?: any;
}

export const FollowUpPopUp: React.FC<FollowUpModalProps> = ({
  open,
  onClose,
  title,
  children,
  width = "95vw",
  maxWidth = "95vw",
  height = "100vh",
  scroll = "paper",
  showCloseIcon = true,
  dialogSx,
  contentSx,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      scroll={scroll}
      sx={{
        "& .MuiDialog-paper": {
          width,
          maxWidth,
          height,
          borderRadius: "16px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          overflow: "hidden",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "blur(4px)",
        },
        ...dialogSx,
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 3,
          fontWeight: 600,
          fontSize: "1.1rem",
          fontFamily: "'Poppins', sans-serif",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "linear-gradient(135deg,rgb(234, 102, 102) 0%,rgb(162, 75, 75) 100%)",
          color: "#ffffff",
          borderBottom: "none",
        }}
      >
        {title}

        {showCloseIcon && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent
        dividers={false}
        sx={{
          p: 0,
          backgroundColor: "#f5f7fa",
          overflow: "hidden",
          ...contentSx,
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default FollowUpPopUp;
